import { RefObject, useEffect, useRef } from "react";

export const DROP_AREA_OVERLAY_ID = "dropZone";

type UseDropAreaOverlayRefReturn = {
  dropZoneElementRef: RefObject<HTMLDivElement | null>;
};

export const useDropAreaOverlayRef = (): UseDropAreaOverlayRefReturn => {
  const dropZoneElementRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    dropZoneElementRef.current = document.createElement("div");
    dropZoneElementRef.current.setAttribute("id", DROP_AREA_OVERLAY_ID);

    dropZoneElementRef.current.style.backgroundColor =
      "color-mix(in srgb, var(--palettePrimary3) 50%, transparent)";
    dropZoneElementRef.current.style.border = "2px dashed var(--palettePrimary0)";
    dropZoneElementRef.current.style.position = "absolute";
    dropZoneElementRef.current.style.top = "0px";

    return () => {
      document.getElementById(DROP_AREA_OVERLAY_ID)?.remove();
    };
  }, []);

  return {
    dropZoneElementRef
  };
};
